import { defineAsyncComponent } from 'vue'

export default defineAsyncComponent(() => import('./sidebar-ai-chat.vue'))
